import React from 'react';

import { Button, Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconArrowBackUp } from '@tabler/icons-react';
import { Dayjs } from 'dayjs';
import useCancelAthleteClass from 'hooks/athleteClass/useCancelAthleteClass';
import { KiloClassAthleteRetrieve } from 'types';

import ModalLeaveWaitlist from './ModalLeaveWaitlist';

type LeaveWaitlistSectionProps = {
  classData: KiloClassAthleteRetrieve;
  athleteKiloClassId: string;
  classStartDateTime: Dayjs;
  waitlistOrder: number | null;
};

const LeaveWaitlistSection = ({
  classData,
  athleteKiloClassId,
  classStartDateTime,
  waitlistOrder,
}: LeaveWaitlistSectionProps): JSX.Element => {
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);

  const leaveWaitlistMutation = useCancelAthleteClass();

  return (
    <>
      <Group px='lg' position='center'>
        <Button
          size='md'
          variant='outline'
          leftIcon={<IconArrowBackUp />}
          onClick={openModal}
          color='red'
          loading={leaveWaitlistMutation.isLoading}
        >
          Leave Waitlist
        </Button>
      </Group>

      <ModalLeaveWaitlist
        opened={modalOpened}
        handleClose={closeModal}
        leaveWaitlistMutation={leaveWaitlistMutation}
        athleteKiloClassId={athleteKiloClassId}
        kiloClass={classData}
        classStartDateTime={classStartDateTime}
        waitlistOrder={waitlistOrder}
      />
    </>
  );
};

export default LeaveWaitlistSection;
